import { httpV1 as http } from '@/services/api';

export async function getCommission({ params }) {
  return http.get('/payments/payment-commission-promoter', { params });
}

export async function getCommissionByProposal({ id, params }) {
  return http.get(`/payments/payment-commission-promoter/proposals/${id}`, { params });
}

export async function getCommissionsFromTheDay({ params }) {
  return http.post('/payments/pix', { params });
}

export async function getCommissionReceipt({ id }) {
  return http.get(`/payments/pix/receipt/${id}`);
}

export async function getCommissionPaymentReport({ params }) {
  return http.get('/payments/commission-summary', { params });
}

export async function getCommissionPaymentMasterReport({ params }) {
  return http.get('/payments/payment-commission-without-promoter', { params });
}

export async function getDetailedCommissionPaymentMasterReport({ params }) {
  return http.get('/payments/payment-commission-without-promoter-detail', { params });
}

export async function getIndicatedCommissionPaymentReport({ params }) {
  return http.get('/payments/indicators-commissions-summary', { params });
}

export async function getIndicatedCommission({ params }) {
  return http.get('/payments/indicators-commissions', { params });
}

export async function getIndicatedCommissionByProposal({ id, params }) {
  return http.get(`/payments/indicators-commissions/${id}/proposals`, { params });
}
